import * as React from 'react';
import { RibbonCustomizerContainer } from 'owa-mail-ribbon-customizer';
import MailAttachmentPickers from './components/MailAttachmentPickers';
import { computedFn } from 'mobx-utils/lib/computedFn';

export const renderExtraMailCommandComponents = computedFn(
    (attachmentInlinePickers: any, attachmentMultiPicker: any) => (
        <>
            <RibbonCustomizerContainer />
            <MailAttachmentPickers
                attachmentInlinePickers={attachmentInlinePickers}
                attachmentMultiPicker={attachmentMultiPicker}
            />
        </>
    )
);
